import React, {  useMemo, useRef } from 'react'
import { useUpdateEffect } from 'react-use'
import _ from 'lodash'
import {
    Button,
    ButtonGroup,
    Grid,
    List,
    ListItem,
    ListItemIcon,
    ListItemSecondaryAction,
    ListItemText,
    Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { fade } from '@material-ui/core/styles/colorManipulator'
import TodayIcon from '@material-ui/icons/Today'
import EventIcon from '@material-ui/icons/Event'
import Forward30Icon from '@material-ui/icons/LowPriority'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'
import LocalAtmIcon from '@material-ui/icons/LocalAtm'
import MoneyIcon from '@material-ui/icons/Money'
import ExtensionIcon from '@material-ui/icons/Extension'
import classNames from 'classnames'
import { useIntl } from 'src/common/razzle-platform-translate'
import {
    PERIODICITY_ALL_TYPE_EXCHANGE_UUID,
    PERIODICITY_NO_RECIPROCAL_EXCHANGE_UUID,
    PERIODICITY_RECIPROCAL_EXCHANGE_UUID
} from 'src/configs'


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    dataPresentationContainer: {
        display: 'flex',
        justifyContent: 'start',
        padding: '5px 0px 15px 0'
    },
    dataItem: {
        height: 60,
        paddingLeft: 10
    },
    dataItemEven: {
        background: fade(theme.palette.primary.main, 0.05),
    },
    dataItemOdd: {
        background: fade(theme.palette.primary.main, 0.1),
    },
    dataItemError: {
        background: 'rgba(251, 135, 135, 0.64)'
    },
    errorDescriptionArea: {
        backgroundColor: 'rgba(251, 135, 135, 0.64)',
        borderTop: '1px solid #00000008'
    }
}))

export const daysInUnity = {
    day: 1,
    week: 7
}

const DisplayDaysResult = (props) => {
    const classes = useStyles()
    const { formatMessage } = useIntl()
    const {
        startDate,
        endDate,
        error,
        selectedAvailability,
        numberOfUnity,
        availabilities,
        unityLables,
        onNumberOfUnityChange,
        onExtraDataChange,
        extraData,
        periodicities
    } = props
    const shouldShowNumberOfUnityError = useRef(true)

    useUpdateEffect(() => {
        shouldShowNumberOfUnityError.current = false
    }, [numberOfUnity])

    const totalPrice = useMemo(() => {
        if (selectedAvailability.subAvailabilities) {
            let price = 0

            for (const subAvailability of selectedAvailability.subAvailabilities) {
                const _startDate = startDate.clone().add(1, 'm')
                const _endDate = endDate.clone().subtract(1, 'm')

                const isStartDateBetweenSubAvailabilityDays = _startDate.isBetween(subAvailability.startDate, subAvailability.endDate)
                const isEndDateBetweenSubAvailabilityDays = _endDate.isBetween(subAvailability.startDate, subAvailability.endDate)

                if (isStartDateBetweenSubAvailabilityDays && isEndDateBetweenSubAvailabilityDays) {
                    return subAvailability.price * numberOfUnity
                } else if (isStartDateBetweenSubAvailabilityDays) {
                    price += subAvailability.price * (subAvailability.endDate.diff(startDate, 'days') / subAvailability.unitNumbers)
                } else if (isEndDateBetweenSubAvailabilityDays) {
                    price += subAvailability.price * (endDate.diff(subAvailability.startDate, 'days') / subAvailability.unitNumbers)
                } else if (subAvailability.startDate.isBetween(startDate, endDate) && subAvailability.endDate.isBetween(startDate, endDate)) {
                    price += subAvailability.price * (subAvailability.endDate.diff(subAvailability.startDate, 'days') / subAvailability.unitNumbers)
                }
            }
            return price
        }
        return selectedAvailability.price * numberOfUnity
    }, [startDate, endDate, numberOfUnity, selectedAvailability])

    const displayUnitPrice = useMemo(() => {
        return selectedAvailability.subAvailabilities ? false : true
    }, [selectedAvailability])

    return (
        <div>
            <div>
                <Grid container direction="column">
                    <div className={classes.dataPresentationContainer} >
                        <List className={classes.root}>
                            <ListItem role={undefined} dense className={classNames(classes.dataItem, classes.dataItemOdd)}>
                                <ListItemIcon >
                                    <TodayIcon />
                                </ListItemIcon>
                                <ListItemText id={'unitPrice'} primary={<Typography>{ formatMessage({ id: 'Date de début', defaultMessage: 'Date de début' }) }</Typography>} />
                                <ListItemSecondaryAction>
                                    <Typography>{startDate.format('DD-MM-YYYY')}</Typography>
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem role={undefined} dense className={classNames(classes.dataItem, error.endDate ? classes.dataItemError : classes.dataItemEven)}>
                                <ListItemIcon >
                                    <EventIcon />
                                </ListItemIcon>
                                <ListItemText id={'unitPrice'} primary={<Typography>{ formatMessage({ id: 'Date de fin', defaultMessage: 'Date de fin' })}</Typography>} />
                                <ListItemSecondaryAction>
                                    <Typography>{endDate.format('DD-MM-YYYY')}</Typography>
                                </ListItemSecondaryAction>
                            </ListItem>
                            {error.endDate &&
                                <ListItem className={classes.errorDescriptionArea}>
                                    {error.endDate}
                                </ListItem>
                            }
                            {periodicities.length > 1 && <ListItem role={undefined} dense className={classNames(classes.dataItem, extraData.is_reciprocal === undefined ? classes.dataItemError : classes.dataItemEven)}>
                                <ListItemIcon >
                                    <ExtensionIcon />
                                </ListItemIcon>
                                <ListItemText id={'unitPrice'} primary={<Typography>{ formatMessage({ id: 'Type de réservation', defaultMessage: 'Type de réservation' }) } *</Typography>} />
                                <ListItemSecondaryAction className='flex flex-col sm:block'>
                                    { selectedAvailability.periodicityUuid === PERIODICITY_ALL_TYPE_EXCHANGE_UUID ?
                                        <React.Fragment>
                                            <Button
                                                variant="contained"
                                                color={extraData.is_reciprocal === true ? 'primary' : 'default'}
                                                style={{marginLeft: 10, marginTop: 5 }}
                                                disableElevation
                                                disableFocusRipple
                                                disableRipple
                                                size="small"
                                                onClick={() => onExtraDataChange({is_reciprocal: true})}>
                                                {_.find(periodicities, { uuid: PERIODICITY_RECIPROCAL_EXCHANGE_UUID })?.label}
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color={extraData.is_reciprocal === false ? 'primary' : 'default'}
                                                style={{ marginLeft: 10, marginTop: 5 }}
                                                disableElevation
                                                disableFocusRipple
                                                disableRipple
                                                size="small"
                                                onClick={() => onExtraDataChange({is_reciprocal: false})}>
                                                {_.find(periodicities, { uuid: PERIODICITY_NO_RECIPROCAL_EXCHANGE_UUID })?.label}
                                            </Button>
                                        </React.Fragment>
                                        :
                                        <Typography>{selectedAvailability.label}</Typography>
                                    }
                                </ListItemSecondaryAction>
                            </ListItem>}
                            <ListItem role={undefined} dense className={classNames(classes.dataItem, error.numberOfUnity || shouldShowNumberOfUnityError.current ? classes.dataItemError : classes.dataItemEven)}>
                                <ListItemIcon >
                                    <Forward30Icon />
                                </ListItemIcon>
                                <ListItemText id={'unitPrice'} primary={<Typography>{ formatMessage({ id: 'Nombre de', defaultMessage: 'Nombre de' }) } {unityLables[selectedAvailability.unit]} </Typography>} />
                                <ButtonGroup>
                                    <Button
                                        disabled={numberOfUnity === 1}
                                        aria-label="reduce"
                                        disableElevation
                                        onClick={() => onNumberOfUnityChange && onNumberOfUnityChange(Math.max(numberOfUnity - 1, 1))}
                                    >
                                        <RemoveIcon fontSize="small" />
                                    </Button>
                                    <Button
                                        disabled={
                                            !endDate.clone().add(selectedAvailability.unitNumbers * daysInUnity[selectedAvailability.unit], 'days').isSameOrBefore(selectedAvailability.endDate)
                                            ||
                                            _.some(_.filter(availabilities, {isAvailable: false}), availability => endDate.clone().set('h', 0).set('m', 1).isBetween(availability.startDate, availability.endDate))
                                        }
                                        aria-label="increase"
                                        disableElevation
                                        onClick={() => onNumberOfUnityChange && onNumberOfUnityChange(numberOfUnity + 1)}
                                    >
                                        <AddIcon fontSize="small" />
                                    </Button>
                                </ButtonGroup>
                                <ListItemSecondaryAction>
                                    <Typography>{numberOfUnity}</Typography>
                                </ListItemSecondaryAction>
                            </ListItem>
                            {error.numberOfUnity &&
                                <ListItem className={classes.errorDescriptionArea} >
                                    {error.numberOfUnity}
                                </ListItem>
                            }
                            {displayUnitPrice && <ListItem role={undefined} dense className={classNames(classes.dataItem, classes.dataItemOdd)}>
                                <ListItemIcon >
                                    <LocalAtmIcon />
                                </ListItemIcon>
                                <ListItemText id={'unitPrice'} primary={<Typography>{ formatMessage({ id: 'Prix unitaire', defaultMessage: 'Prix unitaire' }) }</Typography>} />
                                <ListItemSecondaryAction>
                                    <Typography>{selectedAvailability.price} {`${formatMessage({ id: '€', defaultMessage: '€'})} / ${selectedAvailability.unitNumbers}${unityLables[selectedAvailability.unit]}`}</Typography>
                                </ListItemSecondaryAction>
                            </ListItem>}
                            <ListItem role={undefined} dense className={classNames(classes.dataItem, classes.dataItemEven)}>
                                <ListItemIcon >
                                    <MoneyIcon />
                                </ListItemIcon>
                                <ListItemText id={'unitPrice'} primary={<Typography>{ formatMessage({ id: 'Prix total', defaultMessage: 'Prix total' }) }</Typography>} />
                                <ListItemSecondaryAction>
                                    <Typography  >{totalPrice} { formatMessage({ id: '€', defaultMessage: '€' }) }</Typography>
                                </ListItemSecondaryAction>
                            </ListItem>
                        </List>
                    </div>
                </Grid>
            </div>
        </div>
    )
}

export default DisplayDaysResult
